import type {
    PlayerPreparedSpellMaterializeInput,
    PlayerPreparedSpellMaterializePlan,
} from '../types';

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Plan fetched player-character prepared rows after hoisting and item resolution, without database I/O. */
export function materializePlayerPreparedSpells(
    input: PlayerPreparedSpellMaterializeInput,
): PlayerPreparedSpellMaterializePlan[] {
    const seen = new Set(input.existingSpellIds.filter((id) => id !== ''));
    const plans: PlayerPreparedSpellMaterializePlan[] = [];
    for (const candidate of input.candidates) {
        if (
            candidate.spellId === ''
            || !UUID_PATTERN.test(candidate.spellId)
            || seen.has(candidate.spellId)
            || !candidate.resolved
            || candidate.resolvedItemId === ''
            || candidate.resolvedItemId === '0'
        ) continue;
        plans.push({
            rowToken: candidate.rowToken,
            spellId: candidate.spellId,
            subclassIds: candidate.subclassIds !== null && candidate.subclassIds.length > 0
                ? [...candidate.subclassIds, '']
                : [''],
            spellToken: candidate.spellToken,
        });
        seen.add(candidate.spellId);
    }
    return plans;
}
